import { Component } from '@angular/core';

import { environment } from '@environment';

@Component({
    selector: 'page-content-feature',
    templateUrl: './page-content-feature.component.html',
    styleUrls: ['./page-content-feature.component.less'],
})
export class PageContentFeatureComponent {
    imageLocation: string = environment.ImageLocation;

    id: string;
    mediaFileName: string;
    title: string;
    description: string;
    other: string;

    languageCode: string;
}
